// src/pages/Home.js
import React from "react";
import { Link } from "react-router-dom";
import { FiTarget, FiFeather, FiShield } from "react-icons/fi";
import useSEO from "../seo/useSEO";

export default function Home() {
  // ✅ SEO béton
  useSEO({
    title:
      "Photographe culinaire — restaurants, hôtels & marques | Nancy, Luxembourg, Belgique — Maxime H",
    description:
      "Photographe culinaire pour restaurants, hôtels, traiteurs et marques. Photos de plats, portraits de chefs, reportages et lieux. Basé à Tomblaine/Nancy — déplacements France, Luxembourg, Belgique. Devis sous 24h.",
    canonical: `${window.location.origin}/`,
    image: "/images/og-default.jpg",
  });

  return (
    <main className="home-light">
      {/* HERO */}
      <section className="home-hero-light">
        <div className="container">
          <div className="home-hero-grid">
            {/* Image à gauche */}
            <div className="home-hero-image">
              <img
                src="/images/accueil.jpg"
                alt="Cuisine gastronomique haut de gamme — Maxime H, photographe culinaire"
                loading="eager"
                decoding="async"
              />
            </div>

            {/* Texte à droite */}
            <div className="home-hero-content">
              {/* ✅ H1 plus “SEO” sans sur-optimiser */}
              <h1 className="home-title-light">
                Photographe culinaire pour restaurants, hôtels, traiteurs & marques
                <br />
                Nancy • Grand Est • Luxembourg • Belgique
              </h1>

              {/* ✅ texte légèrement déspamifié + plus orienté bénéfices */}
              <p className="home-intro-light">
                Je suis Maxime, photographe culinaire. J’accompagne les chefs, restaurants,
                hôtels, traiteurs, artisans et maisons d’exception dans la création d’images
                gastronomiques haut de gamme.
                <br /><br />
                Photos de plats, gestes en cuisine, portraits, atmosphères et lieux : chaque visuel est pensé
                pour servir votre communication (site internet, réseaux sociaux, menu, supports imprimés, presse).
                Mon objectif : des images cohérentes, fortes et immédiatement exploitables.
                <br /><br />
                Basé entre Bruxelles et Tomblaine (Nancy), je me déplace en France, au Luxembourg et en Belgique
                pour réaliser des shootings culinaires, reportages en cuisine et prises de vues d’ambiance.
              </p>

              <div className="home-cta-row-light">
                <Link to="/galerie" className="btn-ghost-light">
                  Voir la galerie
                </Link>
                <Link to="/contact" className="btn-ghost-light">
                  Demander un devis en 24h
                </Link>
              </div>

              {/* Cartes avec pictos */}
              <div className="home-cards-row">
                <div className="home-card-light">
                  <div className="home-card-icon">
                    <FiTarget />
                  </div>
                  <h3>Précision</h3>
                  <p>
                    Contrôle de la lumière, des couleurs et des cadrages pour des images fidèles à votre cuisine
                    et à votre identité.
                  </p>
                </div>

                <div className="home-card-light">
                  <div className="home-card-icon">
                    <FiFeather />
                  </div>
                  <h3>Créativité</h3>
                  <p>
                    Une esthétique au service d’un objectif clair : donner envie, renforcer votre image,
                    et convertir (réservation, commande, demande de devis).
                  </p>
                </div>

                <div className="home-card-light">
                  <div className="home-card-icon">
                    <FiShield />
                  </div>
                  <h3>Fiabilité</h3>
                  <p>
                    Repérage, préparation, respect des délais et livrables prêts pour le web, le print
                    et la presse.
                  </p>
                </div>
              </div>
            </div>
            {/* fin content */}
          </div>
        </div>
      </section>

      {/* SECTION : À QUI JE M’ADRESSE */}
      <section className="home-section-light centered">
        <div className="container">
          <div className="home-section-inner-light">
            {/* ✅ H2 ciblé */}
            <h2>Photographie culinaire et reportage pour les professionnels de la gastronomie</h2>

            <p>
              Je crée des images professionnelles pour les restaurants, chefs, hôtels, traiteurs, artisans et producteurs :
              photos de plats, portraits de chefs et brigades, reportages en cuisine, prises de vues de salles et d’ambiances.
              Chaque image est pensée pour valoriser votre établissement : lumière maîtrisée, textures, dressages, atmosphères
              et gestes techniques.
            </p>

            <div className="home-grid-light">
              <div>
                <h3>Chefs &amp; restaurants</h3>
                <p>
                  Plats signatures, menus dégustation, cartes saisonnières, gestes culinaires, service en salle,
                  univers et ambiance.
                </p>
              </div>

              <div>
                <h3>Hôtels &amp; maisons d’exception</h3>
                <p>
                  Restaurants d’hôtels, bars, cocktails, art de la table, espaces, atmosphères premium et storytelling.
                </p>
              </div>

              <div>
                <h3>Traiteurs &amp; événements</h3>
                <p>
                  Cocktails, buffets, banquets, corporate, réceptions : valorisation des plats, du service et des équipes.
                </p>
              </div>

              <div>
                <h3>Artisans &amp; producteurs</h3>
                <p>
                  Produits, ateliers, portraits, terroir, savoir-faire : une image forte et authentique de votre marque.
                </p>
              </div>
            </div>

            {/* ✅ micro-SEO interne : lien vers services */}
            <p className="legal-note" style={{ marginTop: 12 }}>
              Besoin d’un format récurrent (banque d’images) ou d’un reportage ponctuel ?{" "}
              <Link to="/services" style={{ textDecoration: "underline", textUnderlineOffset: 3 }}>
                Voir les prestations
              </Link>.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION : CTA FINAL */}
      <section className="home-section-light home-section-center-light">
        <div className="container">
          <div className="home-section-inner-light">
            <h2>Sublimez votre univers culinaire</h2>
            <p className="home-text-narrow">
              Vous souhaitez renouveler les visuels de votre carte, préparer une ouverture, renforcer l’image de votre
              maison gastronomique ou créer une banque d’images cohérente ? Parlons de votre projet et construisons
              ensemble un shooting sur-mesure.
            </p>

            <div className="home-cta-row-light home-cta-center">
              <Link to="/contact" className="btn-primary-light">
                Demander un devis en 24h
              </Link>
              <Link to="/galerie" className="btn-ghost-light">
                Voir la galerie
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}